import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { TopComponent, TopComponentSize } from '../../components/TopComponent';
import { HeaderTitle } from '../../components/HeaderTitle';
import { PlaylistsSharingGetAccessButton } from '../../playlistsSharing/PlaylistsSharingGetAccessButton';
import { MainNavbar } from '../../../../layouts/MainNavbar';

export const FeaturesPageTop: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <TopComponent size={TopComponentSize.FullWidth} navbarComponent={<MainNavbar />}>
        <Container className="pb-lg-5">
          <Row className="pt-xl-3">
            <Col xs={12} className="text-center d-flex flex-column">
              <HeaderTitle>
                {intl.formatMessage({
                  id: 'sml.web.smart-links.features.title',
                  defaultMessage: 'Smart Links Features'
                })}
              </HeaderTitle>
              <p className="lead">
                {intl.formatMessage({
                  id: 'sml.web.smart-links.features.subtitle',
                  defaultMessage: 'How artists connect better with their fanbase and get more streams.'
                })}
              </p>
            </Col>
            <Col xs={12} className="px-0 justify-content-center d-flex flex-column top-promo-features-img-col">
              <PlaylistsSharingGetAccessButton source="Artist Page Top" />
            </Col>
          </Row>
        </Container>
      </TopComponent>
    </>
  );
};
